import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { humanizeDuration } from '../../../utils/humanizeDuration';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { format } from 'date-fns';
const colorWorkInProgress = '#031e63';
const colorReview = '#068fb1';
const colorMerged = '#33c57b';
export const CycleTimeChart = ({ datasets }) => {
    const { t } = useTranslation();
    const yTicksFormatter = (value) => value ? humanizeDuration(value).replace(' ', '\u00A0') : '';
    const formatTooltipLabel = (value, name, props) => {
        const tooltip = `${t(`prMetrics.${name}.title`)}: ${humanizeDuration(value)}`;
        return [
            _jsxs("div", { children: [_jsx("span", { style: {
                            // eslint-disable-next-line react/prop-types
                            backgroundColor: props.color,
                            border: '1px solid white',
                            display: 'inline-block',
                            height: '10px',
                            marginRight: '5px',
                            width: '10px',
                        } }), tooltip] }, `${name}-wrapper`),
        ];
    };
    return (_jsx(ResponsiveContainer, { width: "100%", height: "100%", children: _jsxs(BarChart, { width: 500, height: 400, data: datasets, margin: { top: 10, right: 0, left: 0, bottom: 30 }, children: [_jsx(CartesianGrid, { syncWithTicks: true }), _jsx(XAxis, { angle: -45, dataKey: "name", interval: 0, scale: "band", tick: {
                        textAnchor: 'end',
                        fontSize: 11,
                    }, tickFormatter: (value) => format(new Date(value), 'LLL dd, y') }), _jsx(YAxis, { tickFormatter: yTicksFormatter, tick: { fontSize: 11 }, interval: 0, style: { whiteSpace: 'nowrap' } }), _jsx(Tooltip, { cursor: false, formatter: (value, name, props) => formatTooltipLabel(value, name, props), itemStyle: {
                        color: 'white',
                        paddingBottom: 0,
                        paddingTop: 0,
                    }, labelStyle: {
                        fontWeight: 'bold',
                        paddingBottom: '5px',
                    }, contentStyle: {
                        fontSize: '10px',
                        backgroundColor: '#212529',
                        color: 'white',
                        whiteSpace: 'pre-line',
                        borderRadius: '0.25rem',
                        borderColor: '#212529',
                    } }), _jsx(Bar, { dataKey: "wip", stackId: "a", fill: colorWorkInProgress }), _jsx(Bar, { dataKey: "review", stackId: "a", fill: colorReview }), _jsx(Bar, { dataKey: "merge", stackId: "a", fill: colorMerged })] }) }));
};
